  // document.addEventListener("DOMContentLoaded", function () {
  //   const logo = document.querySelector(".stick_logo_gallary");
  //   const gallerySection = document.querySelector(".gallery-section");

  //   window.addEventListener("scroll", function () {
  //     const sectionTop = gallerySection.offsetTop;
  //     const sectionBottom = sectionTop + gallerySection.offsetHeight;
  //     const scrollY = window.scrollY + window.innerHeight / 2;

  //     if (scrollY > sectionTop && scrollY < sectionBottom) {
  //       logo.style.display = "block";
  //     } else {
  //       logo.style.display = "none";
  //     }
  //   });
  // });


// document.addEventListener("DOMContentLoaded", function() {
//   var swiper = new Swiper('.swiper-container', {
//     slidesPerView: 1,      
//     freeMode: true,          // Enable smooth free drag
//     freeModeMomentum: true,  // Allow momentum sliding
//     loop: true,             
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//      breakpoints: {
//       767: {
//         slidesPerView: 2,
//       },
//     },
//   });
//   // Function to update the gallery with the selected variant image
//   function updateGalleryImage(imageUrl) {
//     var firstSlideImage = swiper.slides[0].querySelector('.media-gallery__image');
//     if (firstSlideImage) {
//       firstSlideImage.src = imageUrl;
//       firstSlideImage.srcset = imageUrl;
//     }
//     swiper.slideTo(0); // Reset to first slide
//   }

//   // Function to get the image URL for the currently selected color
//   function getImageForSelectedColor() {
//     var selectedColor = document.querySelector('input[name="Color"]:checked');
//     if (selectedColor) {
//       return selectedColor.getAttribute('data-image-url');
//     }
//     return null;
//   }

//   // Event listener for variant swatch inputs (color and size)
//   var swatchInputs = document.querySelectorAll('.product-form__swatch__input');

//   swatchInputs.forEach(function(input) {
//     input.addEventListener('change', function() {
//       if (this.checked) {
//         var imageUrl = this.getAttribute('data-image-url') || getImageForSelectedColor();

//         if (imageUrl && imageUrl.trim() !== "") {
//           updateGalleryImage(imageUrl);
//         }
//       }
//     });
//   });

//   // On page load, simulate the selection of the first variant's color and size
//   function selectFirstVariant() {
//     var firstCheckedSwatch = document.querySelector('.product-form__swatch__input:checked');
//     if (firstCheckedSwatch) {
//       var initialImageUrl = firstCheckedSwatch.getAttribute('data-image-url') || getImageForSelectedColor();
//       if (initialImageUrl) {
//         updateGalleryImage(initialImageUrl);
//       }
//     } else {
//       // If no variant is checked by default, select the first available option
//       var firstColorInput = document.querySelector('input[name="Color"]');
//       var firstSizeInput = document.querySelector('input[name="Size"]');

//       if (firstColorInput) {
//         firstColorInput.checked = true;
//       }
//       if (firstSizeInput) {
//         firstSizeInput.checked = true;
//       }

//       var imageUrl = getImageForSelectedColor();
//       if (imageUrl) {
//         updateGalleryImage(imageUrl);
//       }
//     }
//   }

//   // Execute the function to select the first variant on page load
//   selectFirstVariant();
// });











// product page background slider
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1,
    loop: true,
    freeMode: true,
    grabCursor: true,
    simulateTouch: true,
    touchEventsTarget: "container",
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
    },

    // 👇 Add continuous sliding effect
    autoplay: {
      delay: 0, // no pause between slides
      disableOnInteraction: false, // keep autoplay even when user interacts
    },
    speed: 40000, // controls overall speed — higher = slower slide
    freeModeMomentum: false, // disable momentum bounce
  });
});

//   // Function to update the gallery with the selected variant image
//   function updateGalleryImage(imageUrl) {
//     var firstSlideImage = swiper.slides[0].querySelector('.media-gallery__image');
//     if (firstSlideImage) {
//    var cleanImageUrl = imageUrl.replace(/(_\d+x\d+)?(\.jpg|\.jpeg|\.png|\.gif)/, '$2'); // Removes size from filename

//         // Set the default src for the image (add ?width=600 only if not already present)
//         firstSlideImage.src = cleanImageUrl + "?width=600"; // Default size

//         // Build the srcset for different image sizes
//         firstSlideImage.srcset = `
//             ${cleanImageUrl}?width=180 180w,
//             ${cleanImageUrl}?width=360 360w,
//             ${cleanImageUrl}?width=540 540w,
//             ${cleanImageUrl}?width=720 720w,
//             ${cleanImageUrl}?width=900 900w,
//             ${cleanImageUrl}?width=1080 1080w,
//             ${cleanImageUrl}?width=1296 1296w,
//             ${cleanImageUrl}?width=1512 1512w,
//             ${cleanImageUrl}?width=1728 1728w,
//             ${cleanImageUrl}?width=1868 1868w
//         `.trim();

//         // Set the sizes attribute for responsive images
//         firstSlideImage.sizes = "(min-width: 1400px) 732px, (min-width: 981px) 50vw, calc(100vw - 72px)";
//     }
//     swiper.slideTo(0); // Reset to first slide
//   }

//   // Function to get the image URL for the currently selected color
//   function getImageForSelectedColor() {
//     var selectedColor = document.querySelector('input[name="Color"]:checked');
//     if (selectedColor) {
//       return selectedColor.getAttribute('data-image-url');
//     }
//     return null;
//   }

//   // Function to get the background graphic color from the selected swatch
//   function getBackgroundGraphicColor(input) {
//     var swatchLabel = document.querySelector(`label[for="${input.id}"]`);
//     if (swatchLabel) {
//       var computedStyle = getComputedStyle(swatchLabel.querySelector('.product-form__swatch__label__graphic'));
//       return computedStyle.getPropertyValue('--background-graphic').trim();
//     }
//     return null;
//   }

//   // Event listener for variant swatch inputs (color and size)
//   var swatchInputs = document.querySelectorAll('.product-form__swatch__input');

//   swatchInputs.forEach(function(input) {
//     input.addEventListener('change', function() {
//       if (this.checked) {
//         var imageUrl = this.getAttribute('data-image-url') || getImageForSelectedColor();
//         var backgroundGraphicColor = getBackgroundGraphicColor(this);

//         // Log the background graphic color
//         console.log('Background Graphic Color:', backgroundGraphicColor);

//         // Check if the background graphic contains a URL
//         var isBackgroundGraphicUrl = backgroundGraphicColor.startsWith('url(');

//         // Update gallery image only if background graphic contains a URL
//         if (isBackgroundGraphicUrl && imageUrl && imageUrl.trim() !== "") {
//           updateGalleryImage(imageUrl);
//         }
//       }
//     });
//   });

//   // On page load, simulate the selection of the first variant's color and size
//   function selectFirstVariant() {
//     var firstCheckedSwatch = document.querySelector('.product-form__swatch__input:checked');
//     if (firstCheckedSwatch) {
//       var initialImageUrl = firstCheckedSwatch.getAttribute('data-image-url') || getImageForSelectedColor();
//       var backgroundGraphicColor = getBackgroundGraphicColor(firstCheckedSwatch);

//       // Check if the background graphic contains a URL
//       var isBackgroundGraphicUrl = backgroundGraphicColor.startsWith('url(');

//       if (isBackgroundGraphicUrl && initialImageUrl) {
//         updateGalleryImage(initialImageUrl);
//       }
//     } else {
//       // If no variant is checked by default, select the first available option
//       var firstColorInput = document.querySelector('input[name="Color"]');
//       var firstSizeInput = document.querySelector('input[name="Size"]');

//       if (firstColorInput) {
//         firstColorInput.checked = true;
//       }
//       if (firstSizeInput) {
//         firstSizeInput.checked = true;
//       }

//       var imageUrl = getImageForSelectedColor();
//       var backgroundGraphicColor = getBackgroundGraphicColor(firstColorInput);
//       var isBackgroundGraphicUrl = backgroundGraphicColor.startsWith('url(');

//       if (isBackgroundGraphicUrl && imageUrl) {
//         updateGalleryImage(imageUrl);
//       }
//     }
//   }


//   // Execute the function to select the first variant on page load
//   selectFirstVariant();
// });



// open bydefault first collapsiable tab on product page
document.addEventListener('DOMContentLoaded', function() {
  const firstDetail = document.querySelector('accordion-group details');
  if (firstDetail) {
    firstDetail.setAttribute('open', 'true');
  }
});



// Redirect when click on color variant
// document.addEventListener("DOMContentLoaded", function () {
//     // Select all variant radio inputs inside the variant list
//     const variantRadios = document.querySelectorAll(".varient_list .product-form__swatch__input");

//     // Add a change event listener to each radio button
//     variantRadios.forEach(radio => {
//         radio.addEventListener("change", function () {
//             if (this.checked) {
//                 const selectedVariant = this.value; // Get the value of the selected variant
//                 //console.log("Selected variant value:", selectedVariant);

//                 const currentUrl = window.location.href;
//                // console.log("Current URL:", currentUrl);

//                 const baseUrl = currentUrl.split('/products/')[0]; // Extract base URL
//                // console.log("Base URL:", baseUrl);

//                 const handleParts = currentUrl.split('/products/')[1].split('-');
//                // console.log("Handle parts before change:", handleParts);

//                 // Replace the last part of the handle with the selected variant value
//                 handleParts[handleParts.length - 1] = selectedVariant;
//                // console.log("Handle parts after change:", handleParts);

//                 const newHandle = handleParts.join('-');
//                // console.log("New handle:", newHandle);

//                 const newUrl = `${baseUrl}/products/${newHandle}`;
//                 //console.log("New URL:", newUrl);

//                 // Redirect to the new URL
//                 window.location.href = newUrl;
//             }
//         });
//     });
// });



// delivery date hide for preorder template on product page

let isMainPresent = document.getElementById("pre-order-container");

if (isMainPresent) {
    let calloutTextElement = document.querySelector(".product-single__box__block .callout__content");
    if (calloutTextElement) {
        calloutTextElement.style.display = "none";
       // console.log("Display set to none for .callout__content");
    } else {
       // console.log("Element .product-single__box__block .callout__content not found");
    }
} 


// Add Alt attribute to images
const altimages = document.querySelectorAll('img');
altimages.forEach(image => {
  if (!image.hasAttribute('alt')) {
    // If the alt attribute is missing, add a default alt attribute
    image.setAttribute('alt', 'nomada image');
  }
});


// product page tabs
 document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tabs-product-info .tab');
  const tabContents = document.querySelectorAll('.tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      // Hide all tab contents
      tabContents.forEach(content => content.style.display = 'none');
      
      // Show the corresponding content
      const tabId = this.getAttribute('data-tab');
      document.getElementById(`${tabId}-tab`).style.display = 'block';
      
      // Add active class to the clicked tab
      this.classList.add('active');
    });
  });

  // Set initial active tab
  document.querySelector('.tabs-product-info .tab').click();
});



// naviagtion active class add remove 

document.addEventListener("DOMContentLoaded", function () {
    const navItems = document.querySelectorAll(".primary-nav__item");
    let activeItem = document.querySelector(".primary-nav__item--active");

    // Handle click event
    navItems.forEach(item => {
        item.addEventListener("click", function () {
            if (activeItem) {
                activeItem.classList.remove("primary-nav__item--active");
            }
            this.classList.add("primary-nav__item--active");
            activeItem = this;
        });
    });

    // Handle hover event
    navItems.forEach(item => {
        item.addEventListener("mouseenter", function () {
            navItems.forEach(i => i.classList.remove("primary-nav__item--active"));
        });

        item.addEventListener("mouseleave", function () {
            if (activeItem) {
                activeItem.classList.add("primary-nav__item--active");
            }
        });
    });
});


// Insta Feed Slider
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".main-instagram-feed");
  const prevButton = document.querySelector("[data-navigation-prev]");
  const nextButton = document.querySelector("[data-navigation-next]");

  function getScrollAmount() {
    return container.clientWidth; // Scroll by the visible width
  }

  function updateButtons() {
    prevButton.disabled = container.scrollLeft <= 0;
    nextButton.disabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth;
  }

  prevButton.addEventListener("click", function () {
    container.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
  });

  nextButton.addEventListener("click", function () {
    container.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
  });

  container.addEventListener("scroll", updateButtons);
  updateButtons(); // Initial check
});


// collection tab section js

document.addEventListener('DOMContentLoaded', () => {

  collectoinSubHeading();
});
  function collectoinSubHeading(){
    setTimeout(() => {

      
          const subHeading = document.querySelector(
        'section.collectoin-tab-sec span.sub-heading'
        );

        const currentHandle = window.location.pathname.split('/').pop();

        document.querySelectorAll(
          'section.collectoin-tab-sec .tabs-container a'
        ).forEach(link => {

          link.classList.remove('active');

          if (link.dataset.handle === currentHandle) {
            link.classList.add('active');
          }
        });

        if (!subHeading) return;

        if (currentHandle) {
          subHeading.textContent = currentHandle.replaceAll('-', ' ');
        }
}, 400);
}


//bolding the nav elements
document.addEventListener('DOMContentLoaded', () => {

  const activeItem = document.querySelector(
    '.primary-nav__item--active header-details-disclosure:has([aria-current="page"]) .primary-nav__link'
  );

  const allLinks = document.querySelectorAll(
    'header-details-disclosure:has([aria-current="page"]) .primary-nav__link'
  );

  // remove bold from all
  allLinks.forEach(link => {
    link.style.fontWeight = '400';
  });

  // if active item exists -> bold only that
  if (activeItem) {
    activeItem.style.fontWeight = '700';
  }

  // otherwise bold normal current page item
  else if (allLinks.length) {
    allLinks[0].style.fontWeight = '700';
  }

});


//addding a active class to the div for custom product tabs in collection page when scroll
document.addEventListener('DOMContentLoaded', () => {
window.addEventListener('scroll', function() {

  let div = document.querySelector('.collection-tab-main-container');

  if(window.scrollY > 100){
    div.classList.add('active');
  }else{
    div.classList.remove('active');
  }

});
});